<div class="filter" nhaTest="filter-group">
	<div class="filter-label">
		<button mat-button type="button" (click)="toggleExpand()" nhaTest="filter-header">
			{{ filter().title }}
			<mat-icon iconPositionEnd [nhaTest]="expanded() ? 'filter-header-hide' : 'filter-header-show'">
				{{ expanded() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
			</mat-icon>
		</button>
	</div>

	<div class="filter-items" [ngClass]="{ collapsed: !expanded() }">
		@if (filter().items) {
			@if (isCustom()) {
				<div #custom></div>
			} @else if (isSlider() && sliderData()) {
				<div #slider class="filter-slider">
					@let data = sliderData();
					<div nhaTest="filter-items">
						<mat-slider [min]="data.min" [max]="data.max" [step]="data.interval" [showTickMarks]="true" [discrete]="true" class="nha-filter-slider">
							@if (filter().multiple) {
								<input matSliderStartThumb [value]="selected() ?? 0" (valueChange)="selectSliderLowValue($event)" />
								<input matSliderEndThumb [value]="highSelected() ?? 0" (valueChange)="selectSliderHighValue($event)" />
							} @else {
								<input matSliderThumb [value]="selected()" (valueChange)="selectSliderValue($event)" />
							}
						</mat-slider>
						<div class="min-max">
							<div class="min">{{ filter().items[0].label }}</div>
							<div class="max">{{ filter().items.last().label }}</div>
						</div>
					</div>
				</div>
			} @else {
				<div #default>
					@if (filter().items.length > 15) {
						<mat-form-field appearance="outline" class="full-width filter-search">
							<input
								matInput
								nhaTest="filter-search"
								[value]="searchTerm()"
								(input)="searchTerm.set($event.target.value)"
								placeholder="Enter A {{ filter().title }}"
							/>
						</mat-form-field>
					}

					<!--
						[scroll-if] on each row revealed a restored selection inside the old 150px window.
						The list is no longer capped, so it is inert BY DESIGN and must stay that way: with
						one shared panel scroller, every filter holding a selection would scroll it on init
						and whichever ran last would win, landing the panel on an arbitrary filter. Not a bug
						to fix — see _filters-scroll.scss.
					-->
					<ul nhaTest="filter-items">
						@for (item of filterItems(); track item.id) {
							@let itemCount = countFor(item);
							@let itemDisabled = disabledFor(item);
							<li
								[scroll-if]="item.selected"
								nhaTest="filter-item"
								[class.disabled]="itemDisabled"
								[attr.aria-disabled]="itemDisabled ? 'true' : null"
								[attr.aria-label]="counts() ? itemAriaLabel(item, itemCount) : null"
								(click)="select(filterKey(), filter(), item.id)"
							>
								<i class="material-icons">{{ getFilterIcon | templateFunc: [item] : this }}</i>
								<span class="item-label" nhaTest="item-label">{{ item.label }}</span>
								@if (counts() && itemCount !== null) {
									<span class="item-count">{{ itemCount }}</span>
								}
							</li>
						}
					</ul>
				</div>
			}
		} @else {
			<p class="empty-items-message">{{ filter().emptyItemsMessage ? filter().emptyItemsMessage : 'No items found for this filter.' }}</p>
		}
	</div>
</div>
